export default "/template/resource//static/media/img_sousuo@2x.273a398c.png";